export default "/images/smile.svg?27f2efd881fad623383bc8231c3708bb";